import { render, staticRenderFns } from "./Industry.vue?vue&type=template&id=1e14f310&"
import script from "./Industry.vue?vue&type=script&lang=js&"
export * from "./Industry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports